import "./style.css";
import React from "react";

import backgroundImage from "assets/bge.jpg";

import Container from "components/Container";
import Card from "components/Card";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-cards";

export default function Hero() {
	return (
		<Container containerClass="hero-container ">
			<Container containerClass="hero-card-container">
				<img
					alt="backgroundImg"
					src={backgroundImage}
					className="hero-img"
				/>
				<Container containerClass="hero-card-top">
					<Card
						cardContainerClass="hero-card-container-class"
						cardId="topCard1"
						cardBodyClass="hero-card-body-class"
						cardBody="Jag är en utbildad Fullstackutvecklare i .NET med ett stort intresse för programmering och problemlösning. På min fritid så umgås jag gärna med familjen, sitter med mina egna projekt eller lär mig något nytt."
						cardInfoClass="hero-card-info-class"
						cardInfo="om mig"
					/>
					<Card
						cardContainerClass="hero-card-container-class"
						cardId="topCard2"
						cardBodyClass="hero-card-body-class"
						cardBody="Jag studerade programmet Systemutvecklare .NET på TUC Yrkeshögskola i Linköping. Jag fick både grundläggande och fördjupade kunskaper i .NET ramverket. Vi hade även 2 stycken LIA perioder som sammanlagt varade i 6 månader."
						cardInfoClass="hero-card-info-class"
						cardInfo="utbildning"
					/>
					<Card
						cardContainerClass="hero-card-container-class"
						cardId="topCard3"
						cardBodyClass="hero-card-body-class"
						cardBody="Jag har arbetat som IT-konsult i diverse olika projekt inom webb, system och mobilutvekling. Det viktigaste i arbetet har varit att skriva testbar kod och att ha ett bra samarbete i teamet. Det är kommunikationen som i slutändan leder till en lyckad leverans."
						cardInfoClass="hero-card-info-class"
						cardInfo="arbetslivserfarenhet"
					/>
				</Container>
				<Container containerClass="hero-card-bottom">
					<Card
						cardContainerClass="hero-card-container-class"
						cardId="bottomCard1"
						cardBodyClass="hero-card-body-class"
						cardBody="Som en nyfiken utvecklare så har jag hela tiden testat på samt arbetat med olika språk och ramverk, för att utvidga min kunskap. Jag har suttit en del med webbutveckling och mobilutveckling, men även i andra områden inom IT har jag samlat på mig kunskaper."
						cardInfoClass="hero-card-info-class"
						cardInfo="kunskap"
					/>
					<Card
						cardContainerClass="hero-card-container-class"
						cardId="bottomCard2"
						cardBodyClass="hero-card-body-class"
						cardBody="Vid sidan av min utbilning så brukade jag sitta med Xamarin och lära mig mobilutveckling med .NET, sedan ville jag också fördjupa min kunskap i webbutveckling så jag satt med det ocskå. På senare tid har jag utvecklat mina kunskaper i databaser och även lärt mig kotlin."
						cardInfoClass="hero-card-info-class"
						cardInfo="projekt"
					/>
					<Card
						cardContainerClass="hero-card-container-class"
						cardId="bottomCard3"
						cardBodyClass="hero-card-body-class"
						cardBody="Mitt arbete inom försäljning utvecklade min samarbetsförmåga och fick mig att inse värdet av att kämpa tillsammans, som en enhet, mot ett gemensamt mål. Som utvecklare har jag tagit med mig den erfarenheten och implementerat den i mitt dagliga arbete. På det sättet så bidrar man till drivkraften i teamet."
						cardInfoClass="hero-card-info-class"
						cardInfo="samarbete"
					/>
				</Container>
			</Container>
			<Swiper
				className="mySwiper hero-swiper-mobile"
				modules={[Pagination]}
				breakpoints={{
					749: {
						slidesPerView: 2
					},
				}}
				rewind={true}
				pagination={true}
			>
				<img
					alt="backgroundImg"
					src={backgroundImage}
					className="hero-img"
				/>
				<SwiperSlide>
					<Card
						cardContainerClass="hero-card-container-class"
						cardBodyClass="hero-card-body-class"
						cardBody="Jag är en utbildad Fullstackutvecklare i .NET med ett stort intresse för programmering och problemlösning. På min fritid så umgås jag gärna med familjen, sitter med mina egna projekt eller lär mig något nytt."
						cardInfoClass="hero-card-info-class-mobile"
						cardInfo="om mig"
					/>
				</SwiperSlide>
				<SwiperSlide>
					<Card
						cardContainerClass="hero-card-container-class"
						cardBodyClass="hero-card-body-class"
						cardBody="Jag studerade programmet Systemutvecklare .NET på TUC Yrkeshögskola i Linköping. Jag fick både grundläggande och fördjupade kunskaper i .NET ramverket. Vi hade även 2 stycken LIA perioder som sammanlagt varade i 6 månader."
						cardInfoClass="hero-card-info-class-mobile"
						cardInfo="utbildning"
					/>
				</SwiperSlide>
				<SwiperSlide>
					<Card
						cardContainerClass="hero-card-container-class"
						cardBodyClass="hero-card-body-class"
						cardBody="Jag har arbetat som IT-konsult i diverse olika projekt inom webb, system och mobilutvekling. Det viktigaste i arbetet har varit att skriva testbar kod och att ha ett bra samarbete i teamet. Det är kommunikationen som i slutändan leder till en lyckad leverans."
						cardInfoClass="hero-card-info-class-mobile"
						cardInfo="arbetslivserfarenhet"
					/>
				</SwiperSlide>
				<SwiperSlide>
					<Card
						cardContainerClass="hero-card-container-class"
						cardId="bottomCard1"
						cardBodyClass="hero-card-body-class"
						cardBody="Som en nyfiken utvecklare så har jag hela tiden testat på samt arbetat med olika språk och ramverk, för att utvidga min kunskap. Jag har suttit en del med webbutveckling och mobilutveckling, men även i andra områden inom IT har jag samlat på mig kunskaper."
						cardInfoClass="hero-card-info-class-mobile"
						cardInfo="kunskap"
					/>
				</SwiperSlide>
				<SwiperSlide>
					<Card
						cardContainerClass="hero-card-container-class"
						cardId="bottomCard2"
						cardBodyClass="hero-card-body-class"
						cardBody="Vid sidan av min utbilning så brukade jag sitta med Xamarin och lära mig mobilutveckling med .NET, sedan ville jag också fördjupa min kunskap i webbutveckling så jag satt med det ocskå. På senare tid har jag utvecklat mina kunskaper i databaser och även lärt mig kotlin."
						cardInfoClass="hero-card-info-class-mobile"
						cardInfo="projekt"
					/>
				</SwiperSlide>
				<SwiperSlide>
					<Card
						cardContainerClass="hero-card-container-class"
						cardId="bottomCard3"
						cardBodyClass="hero-card-body-class"
						cardBody="Som säljare så utvecklades min samarbetsförmåga och fick mig att inse värdet av att kämpa tillsammans, som en enhet, mot ett gemensamt mål. Som utvecklare har jag tagit med mig den erfarenheten och implementerat den i mitt dagliga arbete. På det sättet så bidrar man till drivkraften i teamet."
						cardInfoClass="hero-card-info-class-mobile"
						cardInfo="samarbete"
					/>
				</SwiperSlide>
			</Swiper>
		</Container>
	);
}
